<template>
  <label class="label label--base"><slot /></label>
</template>

<script>
export default {
  name: 'AppFormLabel',
}
</script>

<style scoped lang="scss">
.label {
  &.label--base {
    display: block;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
  }
}
</style>
